<script setup></script>

<template>
    <div
        class="modal fade"
        :id="modalId"
        data-bs-backdrop="false"
        tabindex="-1"
        :aria-labelledby="modalId"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="">
                        <p
                            class="text-black text-sm fw-semibold text-center"
                            style="line-height: 2.5"
                        >
                            {{ item.title }}
                        </p>
                    </div>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>

                <div class="modal-body">
                    <div
                        class="row text-center"
                        v-if="item.layout_store == 'classic'"
                    >
                        <div
                            class="col-lg-6"
                            v-for="item in shopify"
                            :key="item.id"
                        >
                            <a
                                :href="
                                    'https://all-my-online-test.myshopify.com/products/' +
                                    item.handle
                                "
                                target="_blank"
                            >
                                <img
                                    :src="item.image.src"
                                    style="width: 170px"
                                />
                            </a>
                            <div class="mt-2 font-light">
                                {{ item.title }}
                            </div>
                            <div class="mt-2">
                                £{{ item.variants[0].price }} GBP
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style></style>

<script>
export default {
    components: {},
    data() {
        return {
            phone: null,
            disabled: false,
        };
    },
    props: ["item", "shopify", "modalId"],
    methods: {},
};
</script>
